import { SellerFilterOption } from '@/components/SellerFilter/SellerFilterUi';
import useSearchProducts from '@/hooks/cart/useSearchProducts';
import { DEFER_SEARCH } from '@/utils/functions';
import { productResponseToProductUi } from '../../mapper';

export function useProductSearchViewController(
  alreadyAddedProductIds: string[]
) {
  const searchProductsHook = useSearchProducts();
  const productOptions =
    searchProductsHook.data?.data
      ?.map((productRespons) => productResponseToProductUi(productRespons))
      .filter((product) => !alreadyAddedProductIds.includes(product.id)) ?? [];

  const scheduleSearch = (query: string) =>
    DEFER_SEARCH(
      query,
      (query) => {
        searchProductsHook.setQuery(query);
      },
      600
    );

  const onFilterChanged = (sellersSelected: SellerFilterOption[]) => {
    searchProductsHook.setSellerFilters(sellersSelected);
  };

  return {
    uiState: { productOptions, isSearching: searchProductsHook.isFetching },
    actions: {
      onFilterChanged,
      scheduleSearch,
    },
  };
}
